// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.6667 10V10.8333C16.6667 14.5152 13.6819 17.5 10 17.5C6.31814 17.5 3.33337 14.5152 3.33337 10.8333V10M10 14.1667C8.15909 14.1667 6.66671 12.6743 6.66671 10.8333V5.83333C6.66671 3.99238 8.15909 2.5 10 2.5C11.841 2.5 13.3334 3.99238 13.3334 5.83333V10.8333C13.3334 12.6743 11.841 14.1667 10 14.1667Z"
    />
  </svg>
);
const IconMicrophone = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconMicrophone;
